// extracted by mini-css-extract-plugin
export default {"main":"CardListItem_main__-b7pn","placeholder":"CardListItem_placeholder__VT2lr","scan":"CardListItem_scan__rffRY"};